import React from 'react'
import { Redirect } from 'react-router-dom'

const IndexHtml = () => (
  <Redirect
    to={{
      pathname: "/login"
    }}
  />
)

export default IndexHtml



// WEBPACK FOOTER //
// ./src/routes/indexHtml/IndexHtml.js